import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-card-element`,
  STATUS_CONTAINER: `${cleanedFilename(__filename)}-status-container`,
};
